import ClientProfileContainer from "../../Components/ClientProfile";
import { useEffect } from "react";
import RoleGuard from "../RoleGuard";
import { useAppSelector } from "../../ReduxToolkit/Hooks";

const ClientProfile = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Client Profile";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer"]}
      />

      {/* Main content */}
      <ClientProfileContainer />
    </>
  );
};

export default ClientProfile;
